var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drill"},[_c('div',{staticClass:"text-large"},[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":_vm.dummy_image,"alt":"ダミードリル"}})])}
var staticRenderFns = []

export { render, staticRenderFns }